// src/components/pages/Home/SpiritualHope/SpiritualHope.styles.ts
import styled, { keyframes } from 'styled-components';

interface SpiritualContainerProps {
  $backgroundImage: string;
}

const fadeInFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeInWithDelay = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const SpiritualContainer = styled.section<SpiritualContainerProps>`
  padding: 2rem 1rem;
  background-image: url(${(props) => props.$backgroundImage});
  background-size: cover;
  background-position: center;
  position: relative; /* To position the overlay correctly */
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow: hidden; /* Ensure content stays within the container */
  border-radius: 10px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.1); /* Semi-transparent overlay */
    z-index: 0; /* Ensure it is behind the content */
  }
`;

export const SpiritualContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  position: relative; /* To place content above the overlay */
  z-index: 1; /* Ensure content is above the overlay */

  h2 {
    font-size: 1.75rem;
    margin-bottom: 1rem;
    color: var(--color-text);
    animation: ${fadeInFromTop} 1s ease-out forwards;
  }

  p {
    font-size: 1.25rem;
    font-style: italic;
    color: var(--color-text);
    animation: ${fadeInWithDelay} 1.5s ease-out forwards;
    animation-delay: 0.5s;
  }
`;
